import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

export class questions{
  categoryId?:String;
  description?: String;
  order?: String;
  required?: String;
  weighting?: Number;
}

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {
  private apiURL = environment.api_cuestionarios_rest;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  
  constructor(
    private cookieService: CookieService,
    private http: HttpClient
  ) {}

  public postQuestion(question){
    const ques: questions = {
      categoryId: question.categoryId,
      description: question.descripcion,
      order: question.order,
      required: question.requerida,
      weighting: 0
    }
    const body = JSON.stringify(ques);
    const apiURL = this.apiURL+"questions";
    return this.http.post(`${apiURL}`,body, {headers: this.headers});
  }
  public deleteQuestion(id: string) {
    const apiURL = this.apiURL+"questions/"+id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
    //return this.http.delete<string>(apiURL + id, {headers: this.headers});
  }
  public updateQuestion(question){
    const ques: questions = {
      description: question.descripcion,
      order: question.order,
      required: question.requerida,
    }
    const body = JSON.stringify(ques);
    const apiURL = this.apiURL+"questions/"+question.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
  public updateQuestionWeighting(question){
    const ques = {
      weighting: question.weighting,
      required: question.required,
    }
    const body = JSON.stringify(ques);
    const apiURL = this.apiURL+"questions/"+question.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
}
